import http from './http';
const PRE_FIX = "construction"; //api 地址公共部分 
const PRE_FIX_ = "auth/api/v1"; //api 地址公共部分 

//登录
export function toLogin(params) {
    return http.post('/auth/api/v1/login', params)
}
//查询质量图
export function getQualityImage(params) {
    return http.get(PRE_FIX + '/pheromone/qualityImage/query', params)
}
//查询作业工效-无人摊压里程
// export function getWorkEfficiencyMileage(params) {
//     return http.get(PRE_FIX + '/workIndex/getWorkEfficiencyMileage', params)
// }
// //查询作业工效-土方压实面积
// export function getRollerWorkEfficiency(params) {
//     return http.get(PRE_FIX + '/workIndex/getRollerWorkEfficiency', params)
// }

//查询缓存的作业工效和进度
export function getWorkProgressEfficiency(params) {
    return http.get(PRE_FIX + '/workIndex/getWorkProgressEfficiency', params)
}

//数字化管理获取车辆信息
export function getEquipCountStatistics(params) {
    return http.get(PRE_FIX_ + '/sysEquip/equip/getEquipCountStatistics', params)
}
//数字化管理获取油耗排行榜
export function getRank(params) {
    return http.get(PRE_FIX + '/equipCenter/newEquipDigitalManage/getRank', params)
}
//数字化管理获取异常分析
export function recordWarningAnalysis(params) {
    return http.get(PRE_FIX + '/equipCenter/newEquipDigitalManage/recordWarningAnalysis/getList', params)
}
//数字化管理获取弹窗分析
export function getDayWarningAnalysisDetails(params) {
    return http.get(PRE_FIX + '/equipCenter/newEquipDigitalManage/getDayWarningAnalysisDetails', params)
}
export function getEquipStatisticByModel(params) {
    return http.get(PRE_FIX + '/equipCenter/newEquipDigitalManage/getEquipStatisticByModel', params)
}
export function getDay(params) {
    return http.get(PRE_FIX + '/equipCenter/newEquipDigitalManage/getDay', params)
}
//数字化管理获取存在的车辆类型
export function getEquipCountByType(params) {
    return http.get(PRE_FIX_ + '/sysEquip/equip/getEquipCountByType', params)
}
//获取每日分析
export function getDayAnalysis(params) {
    return http.get(PRE_FIX + '/equipCenter/newEquipDigitalManage/getDayAnalysis', params)
}

//查询版本列表
export function getPackages(params) {
    return http.get(PRE_FIX + '/version/packages', params)
}
//修改版本
export function setPackages(params) {
    return http.put(PRE_FIX + '/version/package', params)
}
//删除版本
export function deletePackages(params) {
    return http.delete(PRE_FIX + '/version/package', params)
}


//获取工程列表
export function getEnginList(params) {
    return http.get(PRE_FIX + '/projects', params)
}

//获取工程下作业的数据
export function getProjectRoadData(params) {
    return http.get(PRE_FIX + '/roadSection/projectRoadData', params)
}

//新增工程信息
export function addEngin(params) {
    return http.post(PRE_FIX + '/project', params)
}

//激活工程
export function activeEngin(params) {
    return http.put(PRE_FIX + '/project/activate', params)
}

//下载道路数据
export function exportExcelRoadInfo(params){
    return http.getExcel(PRE_FIX + '/road-data/downloadStandardRoadTemplateFile', params)
}

//获取工程详情
export function editEngin(params) {
    return http.put(PRE_FIX + '/project', params)
}
//删除
export function deleteEngin(params) {
    return http.delete(PRE_FIX + '/project', params)
}

//获取工程详情
export function getEnginInfo(params) {
    return http.get(PRE_FIX + '/project/details', params)
}

//获取模板列表
export function getWorkConfig(params) {
    return http.get(PRE_FIX + '/work/configs', params)
}
//查询工艺模板详情
export function getWorkConfigDetails(params) {
    return http.get(PRE_FIX + '/work/config/details', params)
}

//获取作业详情
export function getWorkInfo(params) {
    return http.get(PRE_FIX + '/work/details', params)
}
//获取作业列表
export function getWorks(params) {
    return http.get(PRE_FIX + '/works', params)
}
export function addWork(params) {
    return http.post(PRE_FIX + '/work', params)
}
// export function editWork(params) {
//     return http.post(PRE_FIX + '/updateWork', params)
// }

//获取设备列表
export function getEquipsList(params) {
    return http.get(PRE_FIX + '/equips', params)
}
//根据作业获取设备列表
export function getWorkEquipsList(params) {
    return http.get(PRE_FIX + '/work/equips', params)
}
//根据工程获取设备列表
export function getProjectEquipsList(params) {
    return http.get(PRE_FIX + '/project/equips', params)
}
export function addEquip(params) {
    return http.post(PRE_FIX_ + '/sysEquip/equip', params)
}
export function editEquip(params) {
    return http.put(PRE_FIX_ + '/sysEquip/equip', params)
}
export function deleteEquip(params) {
    return http.delete(PRE_FIX + '/equip', params)
}
//设备报告相关接口
export function addEquipReportManage(params) {
    return http.post(PRE_FIX + '/equipCenter/equipReportManage/add', params)
}
export function updateEquipReportManage(params) {
    return http.post(PRE_FIX + '/equipCenter/equipReportManage/update', params)
}
export function deleteEquipReportManage(params) {
    return http.delete(PRE_FIX + '/equipCenter/equipReportManage/delete', params)
}
// export function getEquipReportManageList(params) {
//     return http.get(PRE_FIX + '/equipCenter/equipReportManage/getList', params)
// }
export function getEquipReportManageList(params) {
    return http.get(PRE_FIX + '/equipCenter/equipReportManage/getSearchReports', params)
}
//获取设备类型
export function getEquipTypeList(params) {
    return http.get(PRE_FIX_ + '/sysEquipType/equipTypes', params)
}
//获取组织
export function getOfficeList(params) {
    return http.get(PRE_FIX_ + '/sysOffice/officeList', params)
}

//获取查询标段-分页
export function getRoadSections(params) {
    return http.get(PRE_FIX + '/roadSections', params)
}
//获取工程下的所有标段
export function getWorkSections(params) {
    return http.get(PRE_FIX + '/workSections', params)
}
//获取工程验收报告
export function getReports(params) {
    return http.get(PRE_FIX + '/projectCenter/checkReportManage/getReports', params)
}

//获取工程进度
export function getAllLayerProcess(params) {
    return http.get(PRE_FIX + '/projectCenter/getAllLayerProcess', params)
}

//获取道路列表
export function getRoadsList(params) {
    return http.get(PRE_FIX + '/roadInfos', params)
}
export function addRoadInfo(params) {
    return http.post(PRE_FIX + '/roadInfo', params)
}
export function editRoadInfo(params) {
    return http.put(PRE_FIX + '/roadInfo', params)
}
export function deleteRoadInfo(params) {
    return http.delete(PRE_FIX + '/roadInfo', params)
}
//增删改层数据
export function addRoad(params) {
    return http.post(PRE_FIX + '/road', params)
}
export function editRoad(params) {
    return http.post(PRE_FIX + '/updateRoad', params)
}
export function deleteRoad(params) {
    return http.delete(PRE_FIX + '/road', params)
}

//获取道路详细数据
export function getRoadCordInfo(params) {
    return http.get(PRE_FIX + '/road-data/points', params)
}
export function getRoadInfo(params) {
    return http.get(PRE_FIX + '/roadInfo', params)
}
export function getRoadInfoDetails(params) {
    return http.get(PRE_FIX + '/roads', params)
}
export function resortRoadOrder(params) {
    return http.put(PRE_FIX + '/sortRoadLayer', params)
}

//计算顶点
export function setCalculateVertex(params) {
    return http.post(PRE_FIX + '/calculateVertex', params)
}

//新增标段
export function addRoadSection(params) {
    return http.post(PRE_FIX + '/roadSection', params)
}
//更新标段
export function editRoadSection(params) {
    return http.post(PRE_FIX + '/updateRoadSection', params)
}
//删除标段
export function deleteRoadSection(params) {
    return http.delete(PRE_FIX + '/roadSection', params)
}
//获取标段详情
export function getRoadSection(params) {
    return http.get(PRE_FIX + '/roadSection',params)
}
//根据标段获取道路数据
export function getRoadSectionPointer(params) {
    return http.get(PRE_FIX + '/roadSection/points',params)
}
//获取日报详情
export function getDayReports(params) {
    return http.get(PRE_FIX + '/day_reports', params)
}

//每日统计-施工进度
export function getDateProcess(params) {
    return http.get(PRE_FIX + '/qualityManage/statistics/process', params)
}
//每日统计-施工时长
export function getDateTime(params) {
    return http.get(PRE_FIX + '/qualityManage/statistics/time', params)
}
//每日统计-压实度合格率
export function getDateIcv(params) {
    return http.get(PRE_FIX + '/qualityManage/statistics/icv', params)
}
//每日统计-摊铺温度
export function getDateTemperature(params) {
    return http.get(PRE_FIX + '/qualityManage/statistics/temperature', params)
}

//作业质量获取条件筛选数据
export function getRoadAndLayerByProjectId(params) {
    return http.get(PRE_FIX + '/projectCenter/getRoadAndLayerByProjectId', params)
}
//作业质量获取作业详情
export function getWorksByZ(params) {
    return http.get(PRE_FIX + '/projectCenter/getWorks', params)
}
//作业质量获取作业进度
export function getWorkProcess(params) {
    return http.get(PRE_FIX + '/projectCenter/getWorkProcess', params)
}
//作业质量获取云图
export function getCloudMap(params) {
    return http.get(PRE_FIX + '/qualityManage/workQuality/cloudMap', params)
}
//作业质量获取热力图
export function getHeatMap(params) {
    return http.get(PRE_FIX + '/qualityManage/workQuality/heatMap', params)
}
//作业质量获取数据分析
export function getRollerDataAnalysis(params) {
    return http.get(PRE_FIX + '/projectCenter/getRollerDataAnalysis', params)
}
//作业质量获取报警数据
export function getRecordWarningList(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordWarning/getList', params)
}
//作业质量获取数据分析-摊铺高程与平整度
export function getWorkQualityStatistics(params) {
    return http.get(PRE_FIX + '/qualityManage/workQuality/statistics', params)
}


//压实质量-碾压遍数
export function rollingQualityTimes(params) {
    return http.get(PRE_FIX + '/qualityManage/rollingQuality/times', params)
}
//压实质量-碾压压实度
export function rollingQualityIcv(params) {
    return http.get(PRE_FIX + '/qualityManage/rollingQuality/icv', params)
}
//压实质量-碾压压实度截面压实过程
export function rollingQualityIcvSection(params) {
    return http.get(PRE_FIX + '/qualityManage/rollingQuality/icvSection', params)
}
//压实质量-高程
export function rollingQualityAltitude(params) {
    return http.get(PRE_FIX + '/qualityManage/rollingQuality/altitude', params)
}
//压实质量-轨迹
export function rollingQualityTrace(params) {
    return http.get(PRE_FIX + '/qualityManage/rollingQuality/trace', params)
}
//压实质量-效率
export function rollingQualityEfficiency(params) {
    return http.get(PRE_FIX + '/qualityManage/rollingQuality/efficiency', params)
}


//摊铺质量-温度
export function pavingQualityTemperature(params) {
    return http.get(PRE_FIX + '/qualityManage/pavingQuality/temperature', params)
}
//摊铺质量-速度
export function pavingQualitySpeed(params) {
    return http.get(PRE_FIX + '/qualityManage/pavingQuality/speed', params)
}
//摊铺质量-轨迹
export function pavingQualityTrace(params) {
    return http.get(PRE_FIX + '/qualityManage/pavingQuality/trace', params)
}
//摊铺质量-效率
export function pavingQualityEfficiency(params) {
    return http.get(PRE_FIX + '/qualityManage/pavingQuality/efficiency', params)
}

// 日报
export function getDayReportInfo(params) {
    return http.get(PRE_FIX + '/day_report', params)
}
// 作业验收报告
export function getWorkReport(params) {
    return http.get(PRE_FIX + '/accept/work/report', params)
}
// 作业验收-施工方意见
export function setCommentWork(params) {
    return http.post(PRE_FIX + '/accept/work/cons_comment', params)
}
// 作业验收-监理方意见
export function setSupervisorWork(params) {
    return http.post(PRE_FIX + '/accept/work/supervisor', params)
}

export function setWorkFile(params) {
    return http.post(PRE_FIX + '/attachment/work/file', params)
}
export function deleteWorkFile(params) {
    return http.delete(PRE_FIX + '/attachment/delete', params)
}
export function editWork(params) {
    return http.post(PRE_FIX + '/updateWork', params)
}
export function deleteWork(params) {
    return http.delete(PRE_FIX + '/work', params)
}

// 工程验收报告
export function getProjectReport(params) {
    return http.get(PRE_FIX + '/accept/project/report', params)
}
// 工程验收-施工方意见
export function setCommentPro(params) {
    return http.post(PRE_FIX + '/accept/project/cons_comment', params)
}
// 工程验收-监理方意见
export function setSupervisorPro(params) {
    return http.post(PRE_FIX + '/accept/project/supervisor', params)
}

// 设备中心/设备监控(guohailiang)
// 获取设备列表
export function getEquipMonitorEquipList(params) {
    return http.get(PRE_FIX + '/equipCenter/equipMonitor/getEquipList', params)
}

// 设备中心/数字化管理(guohailiang)
// 获取设备列表
export function getEquipDigitalManageEquipList(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDigitalManage/getEquipList', params)
}
// 获取设备作业时长
export function getEquipWorkTime(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDigitalManage/getEquipWorkTime', params)
}
// 获取设备油耗排行
export function getEquipOilRank(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDigitalManage/getEquipOilRank', params)
}
// 获取作业里程
export function getEquipMileage(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDigitalManage/getEquipMileage', params)
}
// 获取作业油耗
export function getEquipOilConsumption(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDigitalManage/getEquipOilConsumption', params)
}

//index 首页数据
// 获取工程进度
export function getProjectProcess(params) {
    return http.get(PRE_FIX + '/projectIndex/projectProcess', params)
}
// 获取施工时长
export function getProjectWorkTime(params) {
    return http.get(PRE_FIX + '/projectIndex/workTime', params)
}
// 获取作业状态
export function getProjectWorkStatus(params) {
    return http.get(PRE_FIX + '/projectIndex/workStatus', params)
}
// 获取作业累计时长
export function getProjectworkAddUpTime(params) {
    return http.get(PRE_FIX + '/projectIndex/workAddUpTime', params)
}
// 获取压实度与摊铺温度
export function getIcvAndTemperature(params) {
    return http.get(PRE_FIX + '/projectIndex/icvAndTemperature', params)
}
// 获取当前激活的工程
export function getProjectActivate(params) {
    return http.get(PRE_FIX + '/project/activate', params)
}

// 设备中心》数字化管理，设备列表
export function getEquipMathList(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDigitalManage/getEquipList', params)
}
// 设备中心》设备详情，仪表数据
export function getDigital(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/digitalInstrument', params)
}
// 设备中心》设备详情，设备详情
export function getEquipDetails(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipDetails', params)
}
// 设备中心》设备详情，报表速度
export function getEquipSpeed(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipSpeed', params)
}
// 设备中心》设备详情，报表温度
export function getEquipTemp(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipTemperature', params)
}
// 设备中心》设备详情，获取作业时长
export function getEquipWorktimeN(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipWorkTime', params)
}
// 设备中心》设备详情，获取工作时长
export function getEquipUsageTime(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDetails/getEquipUsageTime', params)
}
// 设备中心》设备详情，获取作业里程
export function getEquipMilage(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipMileage', params)
}
// 设备中心》设备详情，获取时长和里程的四个图表数据
export function getEquipStatistics(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDetails/getEquipStatistics', params)
}
// 设备中心》设备详情，获取作业里程
export function getEquipmentMileage(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDetails/getEquipMileage', params)
}
// 设备中心》设备详情，获取油耗图表
export function getEquipDieselCost(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipDieselCost', params)
}
// 设备中心》设备详情，获取油耗图表new
export function getEquipOil(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDetails/getEquipOil', params)
}

// 设备中心》设备详情，获取油耗表格
export function getEquipDieselTable(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordRefuel/getList', params)
}

// 设备中心》设备详情，增加加油记录
export function addEquipDiesel(params) {
    return http.post(PRE_FIX + '/equipCenter/basicManage/recordRefuel/add', params)
}
// 设备中心》设备详情，查询上线记录
export function getEquipOnline(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordOnline/getList', params)
}
// 设备中心》设备详情，查询作业记录
export function getEquipWorkResume(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordWork/getList', params)
}
// 设备中心》设备详情，查询报警记录
export function getEquipWarnResume(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordWarning/getList', params)
}
// 设备中心》设备详情，解除报警（消除待保养）
export function getEquipClearWarning(params) {
    return http.get(PRE_FIX + '/recordWarning/clearWarning', params)
}
// 设备中心》设备详情，查询保养记录
export function getEquipCareResume(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordMaintenance/getList', params)
}
// 设备中心》设备详情，查询设备使用报告
export function equipUsageReport(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipUsageReport', params)
}
// 设备中心》设备详情，修改加油记录
export function equipUpdateRefuel(params) {
    return http.put(PRE_FIX + '/equipCenter/basicManage/recordRefuel/update', params)
}
// 设备中心》设备详情，删除加油记录
export function equipDeleteRefuel(params) {
    return http.delete(PRE_FIX + '/equipCenter/basicManage/recordRefuel/delete', params)
}
// 设备中心》设备详情，增加保养记录
export function addEquipMaintain(params) {
    return http.post(PRE_FIX + '/equipCenter/basicManage/recordMaintenance/add', params)
}
// 设备中心》设备详情，修改保养记录
export function equipUpdateMaintain(params) {
    return http.put(PRE_FIX + '/equipCenter/basicManage/recordMaintenance/update', params)
}
// 设备中心》设备详情，删除保养记录
export function equipDeleteMaintain(params) {
    return http.delete(PRE_FIX + '/equipCenter/basicManage/recordMaintenance/delete', params)
}
// 设备中心》设备详情，模糊查询保养记录
export function getEquipCareResumeFont(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/recordMaintenance/getListByContent', params)
}
// 设备中心》设备详情，综合查询 参数列表
export function getWorkStatusNames(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDetails/getWorkStatusNames', params)
}
// 设备中心》设备详情，综合查询 查询列表
export function getWorkStatus(params) {
    return http.get(PRE_FIX + '/equipCenter/equipDetails/getWorkStatus', params)
}
// 设备中心》设备详情，综合查询 下载报告
export function exportWorkStatus(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/exportWorkStatus', params)
}
// 报告管理=》维保报告
export function getEquipMaintenanceReport(params) {
    return http.get(PRE_FIX + '/equipCenter/basicManage/equipMaintenanceReport', params)
}

// 设备中心》pdf导出使用报告
export function exportPdfEquipUsageReport(params) {
    return http.getPdf(PRE_FIX + '/exportPdf/equipCenter/basicManage/equipUsageReport', params)
}
// 报告管理=>pdf导出维保报告
export function exportPdfEquipMaintenanceReport(params) {
    return http.getPdf(PRE_FIX + '/exportPdf/equipCenter/basicManage/equipMaintenanceReport', params)
}    
// 组织
export function fetchDeptList(params) {
    return http.get(PRE_FIX_ + '/sysOffice/officeList', params)
}
export function addDept(params) {
    return http.post(PRE_FIX_ + '/sysOffice/office', params)
}
export function modDept(params) {
    return http.put(PRE_FIX_ + '/sysOffice/office', params)
}
export function delDept(params) {
    return http.deleteN(PRE_FIX_ + '/sysOffice/office', params)
}

// 终端录入
export function endpointList(params) {
    return http.get(PRE_FIX_ + '/endpoint/vtsic/list', params)
}
export function addEndPoint(params) {
    return http.post(PRE_FIX_ + '/endpoint/vtsic/register', params)
}
export function freezeEndPoint(params) {
    return http.put(PRE_FIX_ + '/endpoint/vtsic/freeze', params)
}
export function delEndPoint(params) {
    return http.deleteN(PRE_FIX_ + '/endpoint/vtsic/delete', params)
}
export function resetEndPoint(params) {
    return http.post(PRE_FIX_ + '/endpoint/vtsic/resetActivate', params)
}
// 账号
export function fetchUserList(params) {
    return http.get(PRE_FIX_ + '/user/admin/userList', params)
}
export function modUser(params) {
    return http.put(PRE_FIX_ + '/user', params)
}
export function addUser(params) {
    return http.post(PRE_FIX_ + '/admin/register', params)
}
export function delUser(params) {
    return http.deleteN(PRE_FIX_ + '/user', params)
}
export function resetPassWord(params) {
    return http.post(PRE_FIX_ + '/user/admin/resetPassWord', params)
}
export function findOneUserUsingGET(params){
    return http.get(PRE_FIX_+'/user',params);
}
export function resetPhone(params) {
    return http.post(PRE_FIX_ + '/user/admin/resetPhone', params)
}
export function resetPassword(params){
    return http.post(PRE_FIX_+'/user/resetPassWord',params);
}


// 角色
export function getRoleList(params) {
    return http.get(PRE_FIX_ + '/role/roleList', params)
}
export function addRole(params) {
    return http.post(PRE_FIX_ + '/role', params)
}
export function editRole(params) {
    return http.put(PRE_FIX_ + '/role', params)
}
export function delRole(params) {
    return http.deleteN(PRE_FIX_ + '/role', params)
}
// 获取权限
export function getRoleInfo(params) {
    return http.get(PRE_FIX_ + '/permission/menuList', params)
}
// 获取已设置权限
export function getRoleCheckInfo(params) {
    return http.get(PRE_FIX_ + '/role', params)
}
// 获取已设置权限
export function addRolePermission(params) {
    return http.post(PRE_FIX_ + '/role/addRolePermission', params)
}

// 设置首页类型
export function setHomeType(params) {
    return http.post(PRE_FIX + '/setting/setHomeType', params)
}
// 查询用户设置
export function getUserSetting(params) {
    return http.get(PRE_FIX + '/setting/getUserSetting', params)
}
// 租户管理
// 添加租户
export function addCorp(params) {
    return http.post(PRE_FIX_ + '/sysCorp/corp', params)
}
export function fetchCorpList(params) {
    return http.get(PRE_FIX_ + '/sysCorp/corps', params)
}
export function editCorp(params) {
    return http.put(PRE_FIX_ + '/sysCorp/corp', params)
}
export function freezeCorp(params) {
    return http.post(PRE_FIX_ + '/sysCorp/freezeCorp', params)
}
export function delCorp(params) {
    return http.deleteN(PRE_FIX_ + '/sysCorp/corp', params)
}


export function getPostList(params) {
    return http.get(PRE_FIX_ + '/sysPost/posts', params)
}
// 设备中心》excel导出速度使用报告
export function exportExcelEquipSpeedReport(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/equipCenter/equipDetails/speed', params)
}
// 设备中心》excel导出温度使用报告
export function exportExcelEquipTempReport(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/equipCenter/equipDetails/temperature', params)
}
// 设备中心》excel导出其它使用报告
export function exportExcelEquipOtherReport(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/equipCenter/equipDetails/records', params)
}
// 质量管理》excel导出质量报告
export function exportExcelQualityReport(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/qualityManage/workQuality', params)
}
// 质量管理》excel导出摊铺轨迹
export function exportExcelpavingTrace(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/qualityManage/pavingQuality/trace', params)
}
// 质量管理》excel导出压实轨迹
export function exportExcelrollingTrace(params) {
    return http.getExcel(PRE_FIX + '/exportExcel/qualityManage/rollingQuality/trace', params)
}
// 质量管理作业验收报告pdf导出
export function exportPdfworkAccept(params,files) {
    return http.postPdf(PRE_FIX + '/exportPdf/quantity/workAccept', params,files)
}
// 质量管理工程验收报告pdf导出
export function exportPdfprojectAccept(params) {
    return http.postPdf(PRE_FIX + '/exportPdf/quantity/projectAccept', params)
}
// 质量管理工程日报pdf导出
export function exportPdfdayReport(params) {
    return http.postPdf(PRE_FIX + '/exportPdf/quantity/dayReport', params)
}

//设备首页

//分页获取设备上线状态
export function onlineInfo(params){
    return http.get(PRE_FIX + '/equipIndex/onlineInfo',params);
}
//设备详情页获取设备列表
export function getEquipsCodeAndType(params){
    return http.get(PRE_FIX_ + '/sysEquip/getEquipsCodeAndType',params);
}

//设备开机时长/利用率排行
export function getUtilizationAndTimeRank(params){
    return http.get(PRE_FIX + '/equipIndex/getUtilizationAndTimeRank',params);
}
//设备油耗排行榜
export function getEquipOilRanks(params){
    return http.get(PRE_FIX + '/equipIndex/getEquipOilRank',params);
}

//分页获取设备报警
export function warningInfo(params){
    return http.get(PRE_FIX+'/equipIndex/warningInfo',params);
}

//实时数据
export function realTimeData(params){
    return http.get(PRE_FIX+'/equipIndex/realTimeData',params);
}

//每日消耗
export function dayOilConsumption(params){
    return http.get(PRE_FIX+'/equipIndex/dayOilConsumption',params);
}

//每日行驶里程
export function dayMileage(params){
    return http.get(PRE_FIX+'/equipIndex/dayMileage',params);
}

//设备利用率
export function equipUtilization(params){
    return http.get(PRE_FIX+'/equipIndex/equipUtilization',params);
}

//日均作业时长
export function dayAvgWorkTime(params){
    return http.get(PRE_FIX+'/equipIndex/dayAvgWorkTime',params);
}

// 智能压实监控大屏
// 获取作业桩号
export function getPileNumData(params) {
    return http.get(PRE_FIX + '/workIndex/pileNumData', params)
}
// 非标获取时间轴
export function getDateList(params) {
    return http.get(PRE_FIX + '/workIndex/getDateList', params)
}
// 非标获取道路
export function getFbPoints(params) {
    return http.get(PRE_FIX + '/roadSection/points', params)
}
// 摊铺速度
export function getPavingSpeed(params) {
    return http.get(PRE_FIX + '/workIndex/pavingSpeed', params)
}
export function getPavingTemperature(params) {
    return http.get(PRE_FIX + '/workIndex/pavingTemperature', params)
}
export function getRollingSpeed(params) {
    return http.get(PRE_FIX + '/workIndex/rollingSpeed', params)
}
export function getRollingTemperature(params) {
    return http.get(PRE_FIX + '/workIndex/rollingTemperature', params)
}
//非标压实温度速度振幅振频
export function getUnRollingAmplitude(params) {
    return http.get(PRE_FIX + '/workIndex/nonStandardRollingAmplitude', params)
}
export function getUnRollingFrequency(params) {
    return http.get(PRE_FIX + '/workIndex/nonStandardRollingFrequency', params)
}
export function getUnRollingTemperature(params) {
    return http.get(PRE_FIX + '/workIndex/nonStandardRollingTemperature', params)
}
export function getUnRollingSpeed(params) {
    return http.get(PRE_FIX + '/workIndex/nonStandardRollingSpeed', params)
}
//碾压遍数
export function getRollingTimes(params) {
    return http.get(PRE_FIX + '/workIndex/rollingTimes', params)
}
//压实度
export function getRollingIcv(params) {
    return http.get(PRE_FIX + '/workIndex/rollingIcv', params)
}

export function getEquipListOnline() {//查询在线设备
    return http.get('/specialAreaWork/equip/onlineList')
}

//个人设置  -日志查询
export function syslogSearch(params) {
    return http.get( 'loginfo/syslog/pages', params)
}

//获取作业时间列表
export function getWorkTimeList(params) {
    return http.get( PRE_FIX + '/work/times', params)
}

//高级设置相关接口

//查询工程设置
export function getProjectSetting(param){
    return http.get(PRE_FIX+"/setting/getProjectSetting",param);
}

//碾压标准设置-碾压遍数参数保存
export function setValidCompactionNum(param){
    return http.post(PRE_FIX+"/setting/setValidCompactionNum",param);
}

//碾压标准设置-压实度参数保存
export function setValidCompactionIcv(param){
    return http.post(PRE_FIX+"/setting/setValidCompactionIcv",param);
}

//碾压色阶设置-遍数参数保存
export function setRollingColor(param){
    return http.post(PRE_FIX+"/setting/setRollingColor",param);
}

//碾压色阶设置-压实度参数保存
export function setCompactionColor(param){
    return http.post(PRE_FIX+"/setting/setCompactionColor",param);
}

//温度色阶设置-摊铺温度参数保存
export function setTemperatureColor(param){
    return http.post(PRE_FIX+"/setting/setTemperatureColor",param);
}
//色阶设置-摊铺高程参数保存
export function setElevationColor(param){
    return http.post(PRE_FIX+"/setting/setElevationColor",param);
}
//色阶设置-平整度参数保存
export function setEvennessColor(param){
    return http.post(PRE_FIX+"/setting/setEvennessColor",param);
}

//报警设置-报警参数查询
export function getSearchWithPage(param){
    return http.get(PRE_FIX+"/setting/alarmConfig/getSearchWithPage",param);
}

//报警设置-报警参数修改
export function setSearchWithPage(param){
    return http.post(PRE_FIX+"/setting/alarmConfig/update",param);
}

/**
 * 道路生成接口
 */
//查询生成的道路数据
export function roadDataList(param){
    return http.get(PRE_FIX+"/road-data/list",param);
}

//导入设计数据
export function importJdFile(param){
    return http.postFile(PRE_FIX+"/road-data/importJdFile",param);
}

//计算JD参数
export function calculateJdParam(param){
    return http.get(PRE_FIX+"/road-data/calculateJdParam",param);
}

//计算道路数据
export function calculateRoadData(param){
    return http.post(PRE_FIX+"/road-data/calculateRoadData",param);
}

//下载道路生成数据
export function downloadUnTransRoadFile(param){
    return http.getPdf(PRE_FIX+"/road-data/downloadUnTransRoadFile",param);
}

//导入转换规则
export function importTransFile(param){
    return http.postFile(PRE_FIX+"/road-data/importTransFile",param);
}

//道路数据坐标转换
export function transRoadData(param){
    return http.get(PRE_FIX+"/road-data/transRoadData",param);
}

//下载无人驾驶道路数据
export function downloadRoadFile(param){
    return http.getPdf(PRE_FIX+"/road-data/downloadRoadFile",param);
}

//下载模板
export function downloadRoadExampleFile(param){
    return http.getPdf(PRE_FIX+"/road-data/downloadRoadExampleFile",param);
}

//回放
export function getWorkTrack(param){
    return http.get(PRE_FIX+"/workTrack",param);
}
//型号管理
//删除设备型号(支持批量)
export function delSysEquipModel(param){
    return http.delete(PRE_FIX_+"/sysEquipModel/equipModel",param);
}
//获取设备型号信息
export function getSysEquipModel(param){
    return http.get(PRE_FIX_+"/sysEquipModel/equipModel",param);
}
//新增设备型号
export function addSysEquipModel(param){
    return http.post(PRE_FIX_+"/sysEquipModel/equipModel",param);
}
//更新设备型号信息
export function putSysEquipModel(param){
    return http.put(PRE_FIX_+"/sysEquipModel/equipModel",param);
}
//获取设备型号-分页
export function getSysEquipModels(param){
    return http.get(PRE_FIX_+"/sysEquipModel/equipModels",param);
}
//获取指定设备型号信息
export function getEquipModelsByType(param){
    return http.get(PRE_FIX_+"/sysEquipModel/equipModelsByType",param);
}
//获取设备型号
export function getSearchEquips(param){
    return http.get(PRE_FIX+"/equipCenter/equipReportManage/getSearchEquips",param);
}

// 摊铺机行驶综合评价
// 获取故障预警
export function getPageFaultWarning(param){
    return http.get("/analysis/paverAnalysisBigScreen/getPageFaultWarning",param);
}
// 获取维保建议
export function getPageMaintainAdvise(param){
    return http.get("/analysis/paverAnalysisBigScreen/getPageMaintainAdvise",param);
}
// 获取行驶系统综合评分日统计
export function getDayComScore(param){
    return http.get("/analysis/paverAnalysisBigScreen/getDayComScore",param);
}
// 获取行驶系统评分
export function getDrivingSystemScore(param){
    return http.get("/analysis/paverAnalysisBigScreen/getDrivingSystemScore",param);
}
// 获取工况占比详细分布
export function getStatisticOfWorkStatus(param){
    return http.get("/analysis/paverAnalysisBigScreen/getStatisticOfWorkStatus",param);
}
// 获取摊铺机设备列表
export function getSysEquipList(params) {
    return http.get(PRE_FIX_ + '/sysEquip/equip/list', params)
}
// 获取最新分数
export function getRecentlyScore(params) {
    return http.get('/analysis/paverAnalysisBigScreen/getRecentlyScore', params)
}

// 获取施工质量日报
export function getWorkQualityReport(params){
    return http.get(PRE_FIX + '/workQuality/report/getWorkQualityReport', params)
}


// 获取综合评价
export function getTotalEvaluation(params) {
    return http.get('/analysis/paverOperationalEvaluation/getTotalEvaluation', params)
}

// 获取车辆当日轨迹
export function getWorkPath(params) {
    return http.get('/analysis/paverOperationalEvaluation/getWorkPath', params)
}

// 获取作业质量
export function getParkingAndTurn(params) {
    return http.get('/analysis/paverOperationalEvaluation/getParkingAndTurn', params)
}
// 作业质量（当天等料时长和低温天数）
export function getWaitingAndLow(params) {
    return http.get('/analysis/paverOperationalEvaluation/getWaitingAndLow', params)
}

// 作业成本（一周时间的小时油耗和每公里油耗）
export function getHourlyAndMileages(params) {
    return http.get('/analysis/paverOperationalEvaluation/getHourlyAndMileages', params)
}
// 作业成本当日其他指标
export function getWorkCost(params) {
    return http.get('/analysis/paverOperationalEvaluation/getWorkCost', params)
}
// 作业效率（日均里程和日均时长）
export function getWorkEfficiency(params) {
    return http.get('/analysis/paverOperationalEvaluation/getWorkEfficiency', params)
}
// 作业效率（一月开工日分布）
export function getIsStart(params) {
    return http.get('/analysis/paverOperationalEvaluation/getIsStart', params)
}
// 作业数据
export function getWorkRecords(params) {
    return http.get('/analysis/paverOperationalEvaluation/getWorkRecords', params)
}
// 获取车辆列表
export function getPageEquip(params) {
    return http.get('/analysis/paverOperationalEvaluation/getPageEquip', params)
}

//获取需求列表
export function getDemandManage(param){
    return http.get(PRE_FIX+"/demandManage/getPage",param);
}
//获取需求详情
export function getDemandManageInfo(param){
    return http.get(PRE_FIX+"/demandManage/get",param);
}
//新增需求
export function addDemand(params) {
    return http.post(PRE_FIX + '/demandManage/add', params)
}
//修改需求
export function editDemand(params) {
    return http.post(PRE_FIX + '/demandManage/update', params)
}
//删除需求
export function deleteDemand(params) {
    return http.delete(PRE_FIX + '/demandManage/delete', params)
}
// 作业质量导出
export function getWorkQualityReportPdf(params) {
    return http.postPdf(PRE_FIX + '/workQuality/report/getWorkQualityReportPdf', params)
}